import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type OutboundDialIntent = string;
const initialState = '' as OutboundDialIntent;

export const outboundDialIntentSlice = createSlice({
  name: 'outboundDialIntent',
  initialState,
  reducers: {
    setOutboundDialIntent(state, action: PayloadAction<string>) {
      return action.payload;
    },
    clearOutboundDialIntent() {
      return '';
    },
  },
});
